import {Component,} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-dv-dienstverband',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-dv-dienstverband.component.html',
    styleUrl: './tekst-dv-dienstverband.component.scss',
})
export class TekstDvDienstverbandComponent  {

}
